import axios from 'axios';
import { environment } from '../../services/envoirnment';
import { jwtDecode } from 'jwt-decode';
import { getContactId, getToken } from '../../tools/utils';


const api = axios.create({
  baseURL: environment.REACT_APP_WEB_API,
  
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    "Access-Control-Allow-Origin": "*",
    "Head-Key":environment.REACT_APP_HEADERKEY  
  },
});

const isTokenExpired = (token:string) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp! * 1000;
  } catch {
    return true;
  }
};

api.interceptors.request.use(
  async (config) => {
    const token = await getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.params = {
        ...config.params,
        contactId: getContactId(),
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
